import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { PanelProductosService } from '../panelproductos.service';
import { FilterSearchingPanelProductosViewModel, PanelProductosItemResultsViewModel, PanelProductosViewModel } from '../panelproductos.types';

@Component({
    selector: 'app-panelproductos-wrapper',
    templateUrl: './panelproductos-wrapper.component.html',
})
export class PanelProductosWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: PanelProductosItemResultsViewModel | null;
    payload?: FilterSearchingPanelProductosViewModel;
    edition = false;

    listTiposErroresProductos: Tc[];

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private globalService: GlobalService,
        private panelProductosService: PanelProductosService,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.getTiposError();
        this.recoverLastSearch();
    }

    private getTiposError(): void {
        this.globalService.getTiposErrorProductos().subscribe(params => {
            this.listTiposErroresProductos = params;
        });
    }

    private recoverLastSearch() {
        this.payload = this.panelProductosService.getLastSearch();
    }

    onSearch(payload: FilterSearchingPanelProductosViewModel): void {
        if (!payload) {
            return;
        }

        this.payload = { ...payload } as FilterSearchingPanelProductosViewModel;

        this.panelProductosService.getPanelProductos(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingPanelProductosViewModel;
        this.onSearch(payload);
    }

    onReset(): void {
        this.searching = false;
        this.result = null;
        this.panelProductosService.clearLastSearch();
    }

    onEdit(itemId: number | null): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/especies/panelproductos/edit', itemId]);
    }

    onMarcaAltaTraces(item: PanelProductosViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                this.panelProductosService.saveProducto(item).subscribe({
                    next: () => {
                        this.addSuccessMessage('Alta en Traces modificada correctamente');
                        this.recoverLastSearch();
                        this.onSearch(this.payload!);
                    },
                    error: error => {
                        this.addErrorMessage(error);
                    },
                });
            },
        });
    }
}
